//------------------------------------------------------------------------
// Jump Navigation
//------------------------------------------------------------------------
"use strict";
import ExpandToggle from "@threespot/expand-toggle";

export default class SubNav {
  constructor(el) {
    this.el = el;

    // Create a dummy “sentinel” element to determine when the nav is sticky
    this.sentiel = document.createElement("div");
    this.el.parentNode.insertBefore(this.sentiel, this.el);

    // Mobile nav toggle setup
    // NOTE: Breakpoint must match $bp-small in _page-header.scss
    this.mediaQueryList = window.matchMedia("(min-width: 768px)");
    this.toggle = this.el.querySelector(".Subnav-about-toggle");

    // Listen for breakpoint change
    this.mediaQueryList.addEventListener("change", (evt) => {
      if (evt.matches) {
        this.destroyToggle();
      } else {
        this.initToggle();
      }
    });

    // Init on load (mobile only)
    if (!this.mediaQueryList.matches) {
      this.initToggle();
    }

    // Toggle a class when menu is sticky
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.el.classList.toggle("is-sticky", !entry.isIntersecting);
          });
        },
        { threshold: [1] }
      );

      this.observer.observe(this.sentiel);
    }
  }

  initToggle() {
    // Guard in case markup is missing the button
    if (!this.toggle) return;
    // Avoid creating multiple ExpandToggle instances on the same button
    if (this.toggleExpand && this.toggleExpand.destroy) {
      this.toggleExpand.destroy();
    }
    this.toggleExpand = new ExpandToggle(this.toggle);
  }

  destroyToggle() {
    if (this.toggleExpand && this.toggleExpand.destroy) {
      this.toggleExpand.destroy();
      this.toggleExpand = null;
    }
  }
}

function activeItem() {
  // Your existing active state wiring
  let navItems = document.querySelectorAll(".JumpNav-item");
  const hash = window.location.hash;
  const jumpLink = document.querySelectorAll(".JumpNav-item a");

  jumpLink.forEach((href) => {
    if (href.hash === hash) {
      href.parentNode.classList.add("is-active-jump-link");
    }
  });

  navItems.forEach((link) => {
    link.addEventListener("click", function () {
      navItems.forEach((checked) => {
        if (checked.classList.contains("is-active-jump-link")) {
          checked.classList.remove("is-active-jump-link");
        }
      });
      link.classList.add("is-active-jump-link");
    });
  });
}

function init() {
  // Initialize any .JumpNav that hasn't been initialized yet
  const subnavs = document.querySelectorAll(".JumpNav");
  subnavs.forEach((el) => {
    if (el.dataset.jumpnavInit === "1") return; // already done
    new SubNav(el);
    el.dataset.jumpnavInit = "1";
  });

  // Bind activeItem once
  if (!window.__jumpnavActiveBound) {
    activeItem();
    window.__jumpnavActiveBound = true;
  }
}

// Init on initial page load AND when React dispatches the custom event
document.addEventListener("DOMContentLoaded", init);
document.addEventListener("jumpnav:mounted", init);

// (Optional) If you use AJAX/Barba, call init() after swaps as well.
// document.addEventListener("barba:after", init);
